const app = {
	state: {
		platform: 0,
		iPadMode: {
			key: 'none', //是否是ipad模式,三个值,none:不是,vertical:竖屏,horizontal:横屏
			value: new Date().getTime()
		},
		loadingProgress: 0,
		showScanUI: false,
		isSetPwd: 0,
		pwdAgain: false,
		showDownLoadAppIcon: false,
		hallIfmUrl: '',
		gameIfmUrl: '',
		actIfmUrl: '',
		ifmHeight: 'auto',
		ifmWidth: '100%',
		hallZIndex: -1,
		gameZIndex: 2,
		actZIndex: -1,
		blueBg: true,
		appInfo: {},
		identity: undefined,
		channel_id: undefined,
		domain: undefined,
		return_url: undefined,
		server_type: undefined,
		style: 0,
		return_type: undefined,
		logo_type: undefined,
		logo_url: undefined,
		areaSize: 0,
		openGameID: '',
		openGameUrl: '',
		appVersion: '',
		showSnow: false,
		screenDirection: '',
		sizeDeirection: '' /**通过长宽比判断方向 */,
		currentGameID: 0, //当前打开的游戏id
		closeAllPopUp: {
			key: 'all',
			time: new Date().getTime()
		},
		theme: 'default', //default
		themeStatus: 'default', //获取主题皮肤的状态
		isBackground: false, //是否切换后台
		gaussianBlur: false, //是否高斯模糊显示，显示小游戏的时候，对游戏界面做高斯模糊处理
		randomID: null, //本次访问的唯一ID标识符
		showLuckyWheelEntrance: false, //是否显示幸运轮盘入口(服务端返回的状态)
		canShowLuckyWheelEntrance: false, //是否允许显示幸运轮盘入口(客户端的状态)
		luckyRedNum: 0 // 幸运轮盘红点数值
	},
	mutations: {
		SET_APP_INFO: (state, appInfo) => {
			state.appInfo = appInfo;
			for (let i in appInfo) {
				state[i] = appInfo[i];
			}
		},
		SET_HALL_IFM_URL: (state, url) => {
			state.hallIfmUrl = url;
		},
		SET_GAME_IFM_URL: (state, url) => {
			state.gameIfmUrl = url;
		},
		SET_ACT_IFM_URL: (state, url) => {
			state.actIfmUrl = url;
		},
		SET_IFM_HEIGHT: (state, height) => {
			state.ifmHeight = height;
		},
		SET_IFM_WIDTH: (state, width) => {
			state.ifmWidth = width;
		},
		SET_HALL_ZINDEX: (state, e) => {
			state.hallZIndex = e;
		},
		SET_GAME_ZINDEX: (state, e) => {
			state.gameZIndex = e;
		},
		SET_ACT_ZINDEX: (state, e) => {
			state.actZIndex = e;
		},
		SET_BLUE_BG: (state, e) => {
			state.blueBg = e;
		},
		SET_SHOW_DOWN_LOAD_ICON: (state, e) => {
			state.showDownLoadAppIcon = e;
		},
		SET_PLATFORM: (state, e) => {
			state.platform = e;
		},
		SET_SHOW_SCAN_UI: (state, e) => {
			state.showScanUI = e;
		},
		SET_IS_SET_PWD: (state, e) => {
			state.isSetPwd = e;
		},
		SET_DOMAIN: (state, e) => {
			state.domain = e;
		},
		SET_PWD_AGAIN: (state, e) => {
			state.pwdAgain = e;
		},
		SET_IPAD_MODE: (state, e) => {
			state.iPadMode = {
				key: e,
				value: new Date().getTime()
			};
		},
		SET_AREA_SIZE: (state, e) => {
			state.areaSize = e;
		},
		SET_OPEN_GAME_ID: (state, e) => {
			state.openGameID = e;
		},
		SET_OPEN_GAME_URL: (state, e) => {
			state.openGameUrl = e;
		},
		SET_APP_VERSION: (state, e) => {
			state.appVersion = e;
		},
		SET_SHOW_SNOW: (state, e) => {
			state.showSnow = e;
		},
		SET_SCREEN_DIRECTION: (state, e) => {
			state.screenDirection = e;
		},
		SET_SIZE_DIRECTION: (state, e) => {
			state.sizeDeirection = e;
		},
		SET_CLOSE_ALL_POPUP: (state, e) => {
			state.closeAllPopUp = e;
		},
		SET_THEME: (state, e) => {
			state.theme = e;
		},
		SET_BACKGROUND: (state, e) => {
			state.isBackground = e;
		},
		SET_GAUSSIAN_BLUR: (state, e) => {
			state.gaussianBlur = e;
		},
		SET_GAME_ID: (state, e) => {
			state.currentGameID = e;
		},
		SET_RANDOM_ID: (state, e) => {
			state.randomID = e;
		},
		SET_LOADING_PROGRES: (state, e) => {
			state.loadingProgress = e;
		},
		SET_LUCKY_REDNUM: (state, e) => {
			state.luckyRedNum = e;
		},
		SET_SHOW_LUCKY_WHEEL_ENTRANCE: (state, e) => {
			state.showLuckyWheelEntrance = e;
		},
		SET_CAN_SHOW_LUCKY_WHEEL_ENTRANCE: (state, e) => {
			state.canShowLuckyWheelEntrance = e;
		},
		SET_THEME_STATUS: (state, e) => {
			state.themeStatus = e;
		}
	},
	actions: {
		setAppInfo({ commit }, arg) {
			commit('SET_APP_INFO', arg);
		},
		setHallIfmUrl({ commit }, arg) {
			commit('SET_HALL_IFM_URL', arg);
		},
		setGameIfmUrl({ commit }, arg) {
			commit('SET_GAME_IFM_URL', arg);
		},
		setActIfmUrl({ commit }, arg) {
			commit('SET_ACT_IFM_URL', arg);
		},
		setIfmHeight({ commit }, arg) {
			commit('SET_IFM_HEIGHT', arg);
		},
		setIfmWidth({ commit }, arg) {
			commit('SET_IFM_WIDTH', arg);
		},
		setHallZIndex({ commit }, arg) {
			commit('SET_HALL_ZINDEX', arg);
		},
		setGameZIndex({ commit }, arg) {
			commit('SET_GAME_ZINDEX', arg);
		},
		setActZIndex({ commit }, arg) {
			commit('SET_ACT_ZINDEX', arg);
		},
		setBlueBg({ commit }, arg) {
			commit('SET_BLUE_BG', arg);
		},
		setPlatform({ commit }, arg) {
			commit('SET_PLATFORM', arg);
		},
		setShowScanUI({ commit }, arg) {
			commit('SET_SHOW_SCAN_UI', arg);
		},
		setShowDownLoadIcon({ commit }, arg) {
			commit('SET_SHOW_DOWN_LOAD_ICON', arg);
		},
		setIsSetPwd({ commit }, arg) {
			commit('SET_IS_SET_PWD', arg);
		},
		setDomain({ commit }, arg) {
			commit('SET_DOMAIN', arg);
		},
		setPwdAgain({ commit }, arg) {
			commit('SET_PWD_AGAIN', arg);
		},
		setIpadMode({ commit }, arg) {
			commit('SET_IPAD_MODE', arg);
		},
		setAreaSize({ commit }, arg) {
			commit('SET_AREA_SIZE', arg);
		},
		setOpenGameID({ commit }, arg) {
			commit('SET_OPEN_GAME_ID', arg);
		},
		setOpenGameUrl({ commit }, arg) {
			commit('SET_OPEN_GAME_URL', arg);
		},
		setAppVersion({ commit }, arg) {
			commit('SET_APP_VERSION', arg);
		},
		setShowSnow({ commit }, arg) {
			commit('SET_SHOW_SNOW', arg);
		},
		setScreenDirection({ commit }, arg) {
			commit('SET_SCREEN_DIRECTION', arg);
		},
		setSizeDirection({ commit }, arg) {
			commit('SET_SIZE_DIRECTION', arg);
		},
		setCloseAllPopUp({ commit }, arg) {
			commit('SET_CLOSE_ALL_POPUP', {
				time: new Date().getTime(),
				key: arg
			});
		},
		setTheme({ commit }, arg) {
			commit('SET_THEME', arg);
		},
		setBackground({ commit }, arg) {
			commit('SET_BACKGROUND', arg);
		},
		setGaussianBlur({ commit }, arg) {
			commit('SET_GAUSSIAN_BLUR', arg);
		},
		setGameID({ commit }, arg) {
			commit('SET_GAME_ID', arg);
		},
		setRandomID({ commit }, arg) {
			commit('SET_RANDOM_ID', arg);
		},
		setLoadingProgress({ commit }, arg) {
			commit('SET_LOADING_PROGRES', arg);
		},
		setluckyRedNum({ commit }, arg) {
			commit('SET_LUCKY_REDNUM', arg);
		},
		setShowLuckyWheelEntrance({ commit }, arg) {
			commit('SET_SHOW_LUCKY_WHEEL_ENTRANCE', arg);
		},
		setCanShowLuckyWheelEntrance({ commit }, arg) {
			commit('SET_CAN_SHOW_LUCKY_WHEEL_ENTRANCE', arg);
		},
		setThemeStatus({ commit }, arg) {
			commit('SET_THEME_STATUS', arg);
		}
	}
};

export default app;
